module.exports = __webpack_public_path__ + "static/media/parent.186f32bb.jpg";